<div class="flex-container gap-12" style="height: 100%">
  <!-- Header : titre + bouton "Voir tout" à droite (gagne de la place en bas). -->
  <div class="flex-row align-center gap-8 widget-header-row">
    <vl-widget-title [text]="'dashboard_ui.lots_par_etat' | trans" [widget]="widget()" [draggable]="true">
      <ng-content class="drag-handler" select='.drag-handler'></ng-content>
    </vl-widget-title>
    <div class="grow"></div>
    <vl-chips
      size="small"
      [state]="totalLignes() > preview().length ? 'active' : 'enabled'"
      iconLeft="open_in_new"
      matTooltip="Ouvrir la vue détaillée (pivot famille/article/emplacement + export Excel)"
      (action)="openFullList()">
      Voir tout ({{ totalLignes() }})
    </vl-chips>
  </div>

  <!-- ═══ 3 catégories : DDM (warn) / DLC (error, critique) / NC ═══ -->
  <div class="flex-row gap-8 flex-wrap align-center">
    <vl-chips
      size="small"
      [bubble]="ddmItems().length"
      [state]="selected() === 'ddm' ? 'active' : 'enabled'"
      iconLeft="schedule"
      matTooltip="Date de durabilité minimale dépassée — avertissement qualité, override possible avec traçabilité"
      (action)="selected.set('ddm')">DDM dépassées
    </vl-chips>
    <vl-chips
      size="small"
      [bubble]="dlcItems().length"
      [state]="selected() === 'dlc' ? 'active' : (dlcItems().length > 0 ? 'warn' : 'enabled')"
      iconLeft="warning"
      matTooltip="Date limite de consommation dépassée — blocage légal R. 412-21 Code Conso, destruction tracée obligatoire"
      (action)="selected.set('dlc')">DLC dépassées
    </vl-chips>
    @if (dlcImminenteItems().length > 0 || selected() === 'dlcImminente') {
      <vl-chips
        size="small"
        [bubble]="dlcImminenteItems().length"
        [state]="selected() === 'dlcImminente' ? 'active' : 'enabled'"
        iconLeft="hourglass_bottom"
        matTooltip="DLC encore valide mais arrivant à expiration sous 7 jours — fenêtre courte d'action (déstockage, don)"
        (action)="selected.set('dlcImminente')">DLC imminentes (J-7)
      </vl-chips>
    }
    <vl-chips
      size="small"
      [bubble]="data()?.nc?.length"
      [state]="selected() === 'nc' ? 'active' : 'enabled'"
      iconLeft="block"
      matTooltip="Lots en zones non conformes"
      (action)="selected.set('nc')">Lots bloqués (NC)
    </vl-chips>

  </div>

  @if (metadata()?.loading) {
    <div class="widget-content overflow-hidden">
      <ngx-skeleton-loader count="10" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else if (preview().length === 0) {
    <div class="empty-state">
      <mat-icon>inventory_2</mat-icon>
      <span class="caption on-background-alt">Aucun lot dans ce périmètre.</span>
    </div>
  } @else {
    <!-- Sous-titre explicite — sans ça, l'utilisateur peut croire que le
         tableau liste TOUS les lots du périmètre alors que c'est juste le
         top par coût (cf. retour user "mon lot n'apparaît pas mais il est
         dans Voir tout"). -->
    <div class="tiny on-background-alt preview-hint">
      @if (totalLignes() > preview().length) {
        Top {{ preview().length }} sur {{ totalLignes() }} · trié par coût décroissant — voir tout pour la liste complète.
      } @else {
        {{ preview().length }} ligne(s) · trié par coût décroissant.
      }
    </div>

    <!-- ═══ Top 10 lignes (tri par coût total décr.) ═══ -->
    <div class="preview-table-wrapper">
      <table class="preview-table">
        <thead>
          <tr>
            <th>Article</th>
            <th>Lot</th>
            <th>Emplacement</th>
            <th class="num">Qté</th>
            <th class="num">Coût</th>
          </tr>
        </thead>
        <tbody>
          @for (line of preview(); track line.lotId + '|' + line.emplacement) {
            <tr>
              <td class="article-cell">
                <!-- vl-article-small-card affiche image + dénomination + ref
                     avec popover sur clic (navigation vers fiche article). -->
                <vl-article-small-card
                  [articleId]="line.articleId"
                  [showVersions]="false"
                  [showVersionsWarn]="false"/>
              </td>
              <td class="lot-cell">
                <!-- Lot cliquable + DDM/DLC en dessous pour gagner une colonne.
                     vl-date-limite-display gère la coloration (DDM orange /
                     DLC rouge) selon `typeDateLimite`. -->
                <div class="flex-col gap-2 align-start">
                  <vl-lot-card [lotId]="line.lotId" mode="text"/>
                  @if (selected() !== 'nc' && line.dluo) {
                    <vl-date-limite-display
                      [dluo]="line.dluo"
                      [typeDateLimite]="line.typeDateLimite ?? 'DDM'"
                      [format]="line.dluoFormat ?? 'dd/MM/yyyy'"
                      size="compact"/>
                  }
                </div>
              </td>
              <td class="emplacement-cell">
                <span class="emplacement-text" [title]="line.emplacement">
                  {{ line.emplacement }}
                </span>
              </td>
              <td class="num">{{ line.quantite | numberSig }}</td>
              <td class="num cout-cell">{{ line.coutTotal | numberSig }} €</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  }
</div>
